import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileLink',
  standalone: false,
})
export class FileLinkPipe implements PipeTransform {
  public transform(filePath: string, prefix: string, fileSessionUuid: string): string {
    if (!filePath) {
      return null;
    }
    return `${prefix}v1/file/${filePath}?file_session_uuid=${fileSessionUuid}`;
  }
}
